import { Collapse as ChakraCollapse, CollapseProps } from '@chakra-ui/react';
import { FC } from 'react';
type MyCollapseProps = CollapseProps & {
  children: React.ReactNode;
};
export const Collapse: FC<MyCollapseProps> = ({ children, ...props }) => {
  return <ChakraCollapse {...props}>{children}</ChakraCollapse>;
};
